import { t } from '@vk-hr-tek/core/translations';
import { IconNames } from '@vk-hr-tek/ui/Icon';

import { Collection } from '@app/gen/event-type';

export const COLLECTION_ICONS: Record<Collection['type'], IconNames> = {
  vacations: 'calendar_outline',
  absences: 'alarm_outline',
  business_trips: 'plane_outline',
  papers: 'document_text_outline',
  review: 'folder_simple_user_outline',
  competencies: 'document_stats_outline',
  personal: 'user_outline',
  payslips: 'wallet_outline',
  work_arrangement: 'repeat_outline',
  another: 'folder_outline',
};

export const EVENT_ROLES = {
  get employee() {
    return {
      label: t('settings.company.collections.eventTypes.roles.employee'),
      color: 'green',
    };
  },
  get manager() {
    return {
      label: t('settings.company.collections.eventTypes.roles.manager'),
      color: 'blue',
    };
  },
  get group() {
    return {
      label: t('settings.company.collections.eventTypes.roles.specialist'),
      color: 'purple',
    };
  },
};

export const PRIORITIES = {
  get low() {
    return t('settings.company.collections.eventTypes.priority.lowPriority');
  },
  get medium() {
    return t('settings.company.collections.eventTypes.priority.middlePriority');
  },
  get high() {
    return t('settings.company.collections.eventTypes.priority.highPriority');
  },
};
